export const PLUS = 'images/accordion-plus-icon.svg'
export const MINUS = 'images/accordion-minus-icon.svg'
